export default __webpack_public_path__ + "static/media/team34.53d98332.JPG";